var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon blueSVGs",
    width: 18,
    height: 9,
    viewBox: "0 0 18 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1047",
    d: "M1.05282 4.71927C0.913193 4.58576 0.79359 4.46659 0.69553 4.36631C0.791285 4.27472 0.906898 4.16693 1.04102 4.0467C1.48298 3.6505 2.12331 3.12158 2.91391 2.5931C4.50397 1.53021 6.65557 0.5 9 0.5C11.3444 0.5 13.496 1.53021 15.0861 2.5931C15.8767 3.12158 16.517 3.6505 16.959 4.0467C17.0931 4.16693 17.2087 4.27473 17.3045 4.36631C17.2064 4.4666 17.0868 4.58576 16.9472 4.71927C16.5048 5.14225 15.8643 5.70659 15.0737 6.27031C13.4823 7.40501 11.3351 8.5 9 8.5C6.66489 8.5 4.51771 7.40501 2.92632 6.27031C2.13572 5.70659 1.49516 5.14225 1.05282 4.71927Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1048",
    d: "M11.9621 4.64541C11.9621 5.8939 10.7222 7.04864 9.0006 7.04864C7.279 7.04864 6.03906 5.8939 6.03906 4.64541C6.03906 3.39693 7.279 2.24219 9.0006 2.24219C10.7222 2.24219 11.9621 3.39693 11.9621 4.64541Z",
    stroke: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/Eye-icon.2b41b62ba0e195390aaea604c0f89119.svg";
export { ForwardRef as ReactComponent };